import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { TimezoneSelector } from './TimezoneSelector';
import { detectUserTimezone, normalizeTimezone } from '../../utils/timezone';
import { Button } from './Button';

interface TimezoneSetupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (timezone: string) => void;
  isFirstLogin?: boolean; // If true, modal cannot be dismissed
}

export const TimezoneSetupModal: React.FC<TimezoneSetupModalProps> = ({ isOpen, onClose, onConfirm, isFirstLogin = false }) => {
  const [tz, setTz] = useState<string>('UTC');

  useEffect(() => {
    if (isOpen) {
      setTz(normalizeTimezone(detectUserTimezone()));
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Set Your Timezone" size="md">
      <div className="p-6 space-y-6">
        <div className="border-l-4 border-blue-500 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-r-md">
          <p className="text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
            {isFirstLogin
              ? "Welcome! To get started, please set your timezone. This ensures your habit tracking works correctly with your local time."
              : "We detected your timezone. Please confirm or select the correct one. This ensures your habit day boundaries and streaks are calculated accurately."
            }
          </p>
        </div>
        
        <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4 bg-gray-50 dark:bg-gray-800/50">
          <TimezoneSelector value={tz} onChange={setTz} />
        </div>
        
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
          {!isFirstLogin && (
            <Button variant="ghost" onClick={onClose}>Not now</Button>
          )}
          <Button onClick={() => onConfirm(tz)}>
            {isFirstLogin ? 'Set Timezone & Continue' : 'Confirm'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TimezoneSetupModal;
